// extracted by mini-css-extract-plugin
module.exports = {"isi_title":"index-module__isi_title___mZ+Yx","isi_body_list":"index-module__isi_body_list___c2+lZ","isi_body":"index-module__isi_body___urnC2"};